import AxiosInstance from "../../utils/axios";

export type ProductCategory = {
  id: string;
  name: string;
  children: ProductCategory[];
  index: number;
};

async function getProductCategories(context?: {
  signal?: AbortSignal;
}): Promise<ProductCategory[]> {
  return (
    await AxiosInstance.get("/product-category", {
      signal: context && context.signal,
    })
  ).data.data;
}

const ProductCategoryAPI = {
  getProductCategories,
};
export default ProductCategoryAPI;
